/**
 * TSQ SYNC — UAE Local Product Landing System
 * Lightweight, dependency-free countdown timer.
 *
 * Behaviour:
 * - Session-scoped "limited time" countdown (evergreen: a fresh deadline is
 *   set the first time a visitor sees it in a given browser session via
 *   sessionStorage, and persists across reloads within that session).
 * - Never disables or blocks the Add to Cart / checkout flow. When the
 *   timer reaches zero it simply swaps to a configurable "expired" message
 *   and stops — it does not touch the buy button, cart, or checkout.
 * - No external libraries, no network calls, no console errors.
 */
(function () {
  if (customElements.get('countdown-timer')) return;

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.durationMinutes = parseInt(this.dataset.durationMinutes, 10) || 15;
      this.storageKey = 'tsq_countdown_' + (this.dataset.storageKey || 'default');
      this.expiredText = this.dataset.expiredText || '';

      this.daysEl = this.querySelector('[data-cd-days]');
      this.hoursEl = this.querySelector('[data-cd-hours]');
      this.minsEl = this.querySelector('[data-cd-minutes]');
      this.secsEl = this.querySelector('[data-cd-seconds]');
      this.wrapEl = this.querySelector('[data-cd-wrap]');
      this.expiredEl = this.querySelector('[data-cd-expired]');

      this.endTime = this._getOrCreateEndTime();
      this._tick();
      this._interval = setInterval(this._tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this._interval) clearInterval(this._interval);
    }

    _getOrCreateEndTime() {
      try {
        var stored = sessionStorage.getItem(this.storageKey);
        if (stored) {
          var end = parseInt(stored, 10);
          if (end > Date.now()) return end;
        }
      } catch (e) {
        /* sessionStorage unavailable — fall through to in-memory countdown */
      }
      var newEnd = Date.now() + this.durationMinutes * 60 * 1000;
      try {
        sessionStorage.setItem(this.storageKey, String(newEnd));
      } catch (e) {
        /* ignore — non-fatal */
      }
      return newEnd;
    }

    _tick() {
      var remaining = this.endTime - Date.now();

      if (remaining <= 0) {
        clearInterval(this._interval);
        if (this.wrapEl) this.wrapEl.hidden = true;
        if (this.expiredEl) {
          this.expiredEl.hidden = false;
          if (this.expiredText) this.expiredEl.textContent = this.expiredText;
        }
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minsEl) this.minsEl.textContent = String(minutes).padStart(2, '0');
      if (this.secsEl) this.secsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
